import ActivitiesView from "@components/order/components/activity/ActivitiesView";
import AppContext from "@helpers/context";
import {
  addGPEventActivity,
  getGPEventActivityList,
} from "@network/api/gp-event";
import { Notifications } from "d-react-components";
import { map } from "lodash";
import React, { useContext, useRef } from "react";
import { useTranslation } from "react-i18next";

const GPEventDetailActivity = () => {
  const { eventDetail } = useContext(AppContext);
  const activityList = useRef(null);
  const { t } = useTranslation();

  const source = (paging: any) => {
    const body = { id: eventDetail?.id };
    return getGPEventActivityList(paging, body);
  };

  const transformer = (res: any) => {
    const activityList = res?.data?.data?.activities ?? [];
    return map(activityList, (item) => ({
      ...item,
      files: map(item.attachment, (attItem) => attItem?.attachment),
    }));
  };

  const onClickSendComment = (comment: any, attachment: any) => {
    const body = {
      id: eventDetail?.id,
      comment,
      attachment: map(attachment, (item) => item?.key),
    };
    return addGPEventActivity(body).then(() => {
      Notifications.showSuccess(t("addCommentSuccess"));
    });
  };

  return (
    <ActivitiesView
      hideType
      source={source}
      transformer={transformer}
      setRef={(listRefParams: any) => (activityList.current = listRefParams)}
      onClickSendComment={onClickSendComment}
      isInstantUploadAttach
    />
  );
};

export default GPEventDetailActivity;
